<template>
    <d-contract-edit
        v-model      = "edit"
        title        = "Notruf"
        :type-id     = "typeId"
        :contract-id = "contractId"
        :company-id  = "companyId"
        @initialized = "onInitialized"
        @saved       = "onSaved"
    >
        <!--
        <template slot="terms">
            <c-column-header
                class  = "primary mt-0"
                :label = "$t('contract.terms')"
            />

            <div class="lm-border pa-3 pt-0 mt-1">
                <c-contract-esc-terms
                    :contract   = "contract"
                    :readonly   = "false"
                    :show-title = "false"
                    class       = "mt-2"
                    style       = "height: 686px;"
                />
            </div>
        </template>
        -->
    </d-contract-edit>
</template>

<script>

import DContractEdit     from "@/modules/msd/company/contract/components/controls/DContractEdit";
//import CContractEscTerms from "@/modules/msd/company/contract/components/controls/esc/CContractEscTerms";
import Contract from "@/modules/msd/company/contract/service/Contract";
import Core from "@/modules/core/service/Core";
//import CColumnHeader from "@/modules/core/components/utils/CColumnHeader";

export default {
    name: "DContractEscEdit",

    components: {
   //     CColumnHeader,
   //     CContractEscTerms,
        DContractEdit,
    },

    props: {
        value: {

        },

        contractId: {
            required: false,
            type    : Number,
            default : function () {
                return null
            }
        },

        companyId: {
            required: false,
            type    : Number,
            default: function () {
                return null;
            }
        },
    },

    data: () => ({
        edit    : false,
        contract: null,
    }),

    watch: {
        value () {
            this.edit = this.value;
        },

        edit () {
            if (!this.edit) {
                this.$emit("input", false)
            }
        }
    },

    computed: {
        typeId () {
            return Contract.enums.types.esc;
        }
    },

    methods: {
        onInitialized (contract) {
            this.contract = contract;
        },

        onSaved (contract) {
            Core.fire.saved(this, contract);
        }
    }
}
</script>
